import { useEffect, useState, type FormEvent } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from './AuthProvider'
import { BrandLockup } from '../../components/Brand'
import { api } from '../../lib/api'
import { SELECTED_PLAN_PRICE_KEY } from '../../lib/brandStorage'

export function SignUpPage() {
  const { user, signUp, authConfigured } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const selectedPlanCode = searchParams.get('plano') ?? ''
  const selectedPriceId = searchParams.get('preco') ?? ''
  const plans = useQuery({ queryKey: ['public-plans'], queryFn: api.publicPlans })
  const selectedPlan = plans.data?.items.find(plan => plan.code === selectedPlanCode && plan.prices.some(price => price.id === selectedPriceId))
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (selectedPriceId) localStorage.setItem(SELECTED_PLAN_PRICE_KEY, selectedPriceId)
  }, [selectedPriceId])

  if (user) return <Navigate to="/onboarding" replace />

  async function submit(event: FormEvent) {
    event.preventDefault()
    setSubmitting(true)
    setError('')
    try {
      const result = await signUp(email, password, fullName)
      if (result.confirmationRequired) {
        setMessage('Enviamos um link de confirmação para seu email. Confirme antes de entrar.')
      } else {
        navigate('/onboarding', { replace: true })
      }
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Não foi possível criar a conta.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-card">
        <Link className="auth-back" to="/">← Voltar ao site</Link>
        <BrandLockup className="auth-brand" />
        <p className="eyebrow">COMECE A COMPOR SUA OPERAÇÃO</p>
        <h1>Crie sua conta</h1>
        <p className="muted">Comece com 14 dias de avaliação.</p>
        {selectedPlan && <p className="selected-plan">Plano escolhido <strong>{selectedPlan.name}</strong></p>}
        {!authConfigured && <p className="error" role="status">Novos cadastros serão liberados quando a autenticação do ambiente for configurada.</p>}
        {message ? (
          <div className="success" role="status">{message}<p><Link to="/entrar">Ir para o login</Link></p></div>
        ) : (
          <form className="stack" onSubmit={submit}>
            <label>Nome completo<input value={fullName} onChange={event => setFullName(event.target.value)} minLength={2} required /></label>
            <label>Email<input type="email" autoComplete="email" value={email} onChange={event => setEmail(event.target.value)} required /></label>
            <label>Senha<input type="password" autoComplete="new-password" value={password} onChange={event => setPassword(event.target.value)} minLength={8} required /></label>
            {error && <p className="error">{error}</p>}
            <button disabled={submitting || !authConfigured}>{submitting ? 'Criando…' : 'Criar conta'}</button>
          </form>
        )}
        <p className="auth-footer">Já possui conta? <Link to="/entrar">Entrar</Link></p>
      </section>
    </main>
  )
}
